export enum LocalStorageEnum {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  CONNECTOR = 'connector',
  ACCOUNT = 'account',
  USER_ID = 'userId',
  IS_ADMIN = 'isAdmin',
  WALLET_CONNECT = 'walletconnect',
}
